<template>
  <div class="animated fadeIn">

    <div class="container bmw-cockpit">
      <div class="row">
        <div class="col-xl">
          <div ref="cockpit-and-filter" class="card">
            <div class="card-header" >
              <div class="form-row">
                <div class="form-group col-md-2">
                  <treeselect :placeholder="$t('Webportal.BrandFilter.Placeholder')"
                              ref="brandTreeselect"
                              instance-id="Brand"
                              v-model="selection.Brand"
                              :options="optionsdata.Brand"
                              :auto-load-root-options="false"
                              :multiple="true"
                              :max-height="600"
                              :searchable="true"
                              :clearable="true"
                              :disableFuzzyMatching="true"
                              :showCount="true"
                              :flat="false"
                              value-consists-of="LEAF_PRIORITY"
                              showCountOf="LEAF_DESCENDANTS"
                              search-nested
                              :disabled="isLoading"
                              @open="handleOpenBrand"
                              @select="handleSelectBrand"
                              @deselect="handleDeselectBrand"
                              @close="handleCloseBrand"
                              @input="handleInputBrand"  />
                </div>

                <div class="form-group col-md-4">
                  <treeselect :placeholder="$t('Webportal.ScenarioFilter.Placeholder')"
                              ref="surveysTreeselect"
                              instance-id="Surveys"
                              v-model="selection.Surveys"
                              :options="optionsdata.Surveys"
                              :auto-load-root-options="false"
                              :multiple="true"
                              :searchable="false"
                              :disableFuzzyMatching="true"
                              :showCount="true"
                              :flat="false"
                              value-consists-of="LEAF_PRIORITY"
                              showCountOf="LEAF_DESCENDANTS"
                              @select="handleSelect"
                              @deselect="handleDeselect"
                              @close="handleClose"
                              @input="handleInput"
                              :disabled="!selection.Brand || isLoading" />
                </div>

                <div class="form-group col-md-3">
                  <treeselect :placeholder="$t('Webportal.WaveFilter.Placeholder')"
                              ref="waveTreeselect"
                              instance-id="Waves"
                              v-model="selection.Waves"
                              :options="optionsdata.Waves"
                              :auto-load-root-options="false"
                              :multiple="true"
                              :searchable="true"
                              :disableFuzzyMatching="true"
                              :showCount="true"
                              :flat="true"
                              showCountOf="LEAF_DESCENDANTS"
                              @select="handleSelect"
                              @deselect="handleDeselect"
                              @close="handleClose"
                              @input="handleInput"
                              :disabled="!isWaveFilterEnabled || isLoading" />
                </div>

                <div class="form-group col-md">
                  <treeselect :placeholder="$t('Webportal.RegionFilter.Placeholder')"
                              ref="regionsTreeselect"
                              instance-id="Regions"
                              v-model="selection.Regions"
                              :options="optionsdata.Regions"
                              :auto-load-root-options="false"
                              :limit="2"
                              :multiple="true"
                              :searchable="true"
                              :disableFuzzyMatching="true"
                              :showCount="true"
                              :flat="true"
                              showCountOf="LEAF_DESCENDANTS"
                              @select="handleSelect"
                              @deselect="handleDeselect"
                              @close="handleClose"
                              @input="handleInput"
                              :disabled="!isRegionFilterEnabled || isLoading" />
                </div>

                <div class="form-group col-md">
                  <treeselect :placeholder="$t('Webportal.SubregionFilter.Placeholder')"
                              ref="subregionTreeselect"
                              instance-id="Subregions"
                              v-model="selection.Subregions"
                              :options="optionsdata.Subregions"
                              :auto-load-root-options="false"
                              :limit="2"
                              :multiple="true"
                              :searchable="true"
                              :disableFuzzyMatching="true"
                              :showCount="true"
                              :flat="true"
                              showCountOf="LEAF_DESCENDANTS"
                              @select="handleSelect"
                              @deselect="handleDeselect"
                              @close="handleClose"
                              @input="handleInput"
                              :disabled="!isSubregionFilterEnabled || isLoading" />
                </div>

              </div>

              <div class="form-row">

                <div class="form-group col-md-2">
                  <treeselect :placeholder="$t('Webportal.DashboardBMW.NSCFilter.Placeholder')"
                              ref="nscsTreeselect"
                              instance-id="NSCs"
                              v-model="selection.NSCs"
                              :options="optionsdata.NSCs"
                              :auto-load-root-options="false"
                              :limit="2"
                              :multiple="true"
                              :searchable="true"
                              :disableFuzzyMatching="true"
                              :showCount="true"
                              :flat="true"
                              showCountOf="LEAF_DESCENDANTS"
                              @select="handleSelect"
                              @deselect="handleDeselect"
                              @close="handleClose"
                              @input="handleInput"
                              :disabled="!isNscFilterEnabled || isLoading" />
                </div>

                <div class="form-group col-md">
                  <treeselect :placeholder="$t('Webportal.DashboardBMW.NSCSubregionFilter.Placeholder')"
                              ref="nscsubTreeselect"
                              instance-id="SubNSCs"
                              v-model="selection.SubNSCs"
                              :options="optionsdata.SubNSCs"
                              :auto-load-root-options="false"
                              :limit="2"
                              :multiple="true"
                              :searchable="true"
                              :disableFuzzyMatching="true"
                              :showCount="true"
                              :flat="true"
                              showCountOf="LEAF_DESCENDANTS"
                              @select="handleSelect"
                              @deselect="handleDeselect"
                              @close="handleClose"
                              @input="handleInput"
                              :disabled="!isNscSubFilterEnabled || isLoading" />
                </div>

                <div class="form-group col-md">
                  <treeselect :placeholder="$t('Webportal.AreaFilter.Placeholder')"
                              ref="areasTreeselect"
                              instance-id="Areas"
                              v-model="selection.Areas"
                              :options="optionsdata.Areas"
                              :auto-load-root-options="false"
                              :limit="2"
                              :multiple="true"
                              :searchable="true"
                              :disableFuzzyMatching="true"
                              :showCount="true"
                              :flat="true"
                              showCountOf="LEAF_DESCENDANTS"
                              @select="handleSelect"
                              @deselect="handleDeselect"
                              @close="handleClose"
                              @input="handleInput"
                              :disabled="!isAreaFilterEnabled || isLoading" />
                </div>

                <div class="form-group col-md">
                  <treeselect :placeholder="$t('Webportal.DashboardBMW.DealergroupFilter.Placeholder')"
                              ref="dealergroupsTreeselect"
                              instance-id="Dealergroups"
                              v-model="selection.Dealergroups"
                              :options="optionsdata.Dealergroups"
                              :auto-load-root-options="false"
                              :limit="2"
                              :multiple="true"
                              :searchable="true"
                              :disableFuzzyMatching="true"
                              :showCount="true"
                              :flat="true"
                              showCountOf="LEAF_DESCENDANTS"
                              @select="handleSelect"
                              @deselect="handleDeselect"
                              @close="handleClose"
                              @input="handleInput"
                              :disabled="!isDealergroupFilterEnabled || isLoading" />
                </div>

                <div class="form-group col-md-3">
                  <CustomTreeSelect :placeholder="$t('Webportal.DashboardBMW.OutletFilter.Placeholder')"
                              ref="outletsTreeselect"
                              instance-id="ClientLocations"
                              v-model="selection.ClientLocations"
                              :options="optionsdata.ClientLocations"
                              :limit="2"
                              :multiple="true"
                              :showCount="true"
                              :flat="true"
                              showCountOf="LEAF_DESCENDANTS"
                              @select="handleSelect"
                              @deselect="handleDeselect"
                              @close="handleClose"
                              @input="handleInput"
                              :disabled="!isOutletsFilterEnabled || isLoading">
                    <label  slot="option-label"
                            slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }"
                            :class="labelClassName">
                      <span v-if="node.raw.isActive" v-b-tooltip.hover.nofade="toolTipDelay" :title="getLocationActiveText()">
                        <font-awesome-icon :icon="['far', 'lightbulb-on']" />
                      </span>
                      <span v-if="!node.raw.isActive" v-b-tooltip.hover.nofade="toolTipDelay" :title="getLocationInactiveText()">
                        <font-awesome-icon :icon="['far', 'lightbulb-slash']" />
                      </span>
                      {{ node.label }}
                    </label>
                  </CustomTreeSelect>
                </div>
              </div>

              <div class="form-row">
                <div class="col">
                  <div class="headinfos">
                    <h3 v-if="!isBmwMoto && !isGebrauchtwagen && !isUsedCar && !isUsedBike && !isBmw2020">{{ $t('Webportal.DashboardBMW.HeadlineMysCarSalesPerformance') }}<br/></h3>
                    <h3 v-if="isBmw2020">{{ $t('Webportal.DashboardBMW.HeadlineMysCarSalesPerformance') }}<br/>{{ $t('Webportal.DashboardBMW.NSC') }}: Q2 2020 ({{ $t('Webportal.Dashboard.KPIOVERVIEW') }})</h3>
                    <h3 v-if="isBmwMoto">{{ $t('Webportal.DashboardBMWMoto.SalesPerformance') }}<br/></h3>
                    <h3 v-if="isUsedBike">{{ $t('Webportal.DashboardBMWUsedBike.SalesPerformance') }}<br/></h3>
                    <div>
                      <h3 v-if="isGebrauchtwagen">{{ $t('Webportal.DashboardBMW.Gebrauchtwagen')}}<br/></h3>
                    </div>
                    <div>
                      <h3 v-if="isUsedCar">{{ $t('Webportal.Dashboard.UsedCarSalesPerformance')}}<br/></h3>
                    </div>
                  </div>
                </div>

                <div class="col-auto col-md-auto" style="height: 100%; display: grid;">
                  <div style="padding-top: 6px;">
                    <label class="col-form-label pt-0" style="vertical-align: middle;">
                      {{ $t('Webportal.Dashboard.AutoFilter') }}
                      <span v-b-tooltip.hover.nofade="toolTipDelay" :title="$t('Webportal.Dashboard.AutoFilter.Tooltip')">
                        <font-awesome-icon  :icon="['fas', 'info-circle']" />
                      </span>
                    </label>
                    <label class="switch switch-label switch-primary" style="margin-bottom: 6px !important; vertical-align: middle;">
                      <input  class="switch-input"
                              type="checkbox"
                              @change="autoFilterSwitchChanged"
                              v-model="autoFilter.isEnabled"
                              :disabled="isLoading">
                      <span class="switch-slider" data-checked="On" data-unchecked="Off"></span>
                    </label>
                  </div>
                </div>
                <div  class="col-auto col-md-auto" 
                      :style="{ display: !autoFilter.isEnabled ? 'none' : 'inherit' }">
                  <button @click="invokeDashboardApi"
                          class="btn btn-primary"
                          style="width:8rem;"
                          :disabled="autoFilter.isEnabled || isLoading">
                    <font-awesome-icon :icon="['fas', 'sync']" />&nbsp;&nbsp;{{ $t('Webportal.Dashboard.AutoFilter.ButtonText') }}
                  </button>
                </div>

                <div class="col-auto"></div>
                <div class="col-auto"></div>

                <div class="col-auto col-md-auto">
                  <exportelementbutton elementRef="cockpit" right
                                       :additionalElements="[{ Name: $t('Webportal.Dashboard.Export.IncludeFilter'),
                                                               ElementRef: 'cockpit-and-filter' }]"
                                       fileName="Cockpit"
                                       :disabled="showPlaceholder || isLoading" />
                </div>
              </div>
            </div>

            <div ref="cockpit" v-bind:class="{ spinner: isLoading, outdated: isOutdated && isRefreshDisabled }">
              <div class="card-body card-body-spacer">
                <compare-board  v-if="!isLoading && !isOutdated && dashdata && dashdata.length > 0" 
                                :dashdata="dashdata"
                                :optionsdata="optionsdata"
                                :selection="selection"
                                :history="history"
                                :pageState="pageState"
                                :leadFuThresholds="leadFuThresholds"
                                :lmThresholds="lmThresholds"
                                :thresholds="thresholds" />

                <div class="emptyplacehold" v-if="showEmptyPlaceholder()">
                  {{ $t('Webportal.DashboardBMW.NoDataFound')}}
                </div>

                <div class="emptyplacehold" v-if="isLoading">
                  {{ $t('Webportal.Dashboard.Loading')}}
                </div>

                <!-- Refresh-Button -->
                <div  v-if="isOutdated && !isLoading" 
                      :class="{ outdated: isLoading }">
                  <div  class="col-auto col-md-auto text-center">
                    <button @click="invokeDashboardApi" 
                            class="btn btn-primary" size="md"
                            style="width:8rem; margin-top: 10rem; margin-bottom: 10rem;"
                            v-b-tooltip.hover.nofade="toolTipDelay" 
                            :title="$t('Webportal.Dashboard.AutoFilter.ButtonTooltip')"
                            :disabled="autoFilter.isEnabled || isLoading || selection.Brand.length === 0 || selection.Surveys.length === 0">
                      <font-awesome-icon :icon="['fas', 'sync']" />&nbsp;&nbsp;{{ $t('Webportal.Dashboard.AutoFilter.ButtonText') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal ref="modalTooMuchWaves" id="modal-center" centered :title="$t('Webportal.Dashboard.Dialog.MaxWaves.Title')">
      <p class="my-4">{{ $t('Webportal.Dashboard.Dialog.MaxWaves.Text') }}</p>
      <div slot="modal-footer" class="w-100">
        <b-btn size="sm" class="float-right" variant="primary" @click="closeInfoDialog">
          {{ $t('Webportal.Dashboard.Ok') }}
        </b-btn>
      </div>
    </b-modal>
  </div>

</template>


<script>
  import ActiveInactiveTexts from '@/mixins/ActiveInactiveTexts';
  import AuthenticationService from "@/services/AuthenticationService";
  import axios from 'axios'
  import BrandMixin from '@/mixins/BrandMixin';
  import CancelToken from '@/mixins/CancelToken';
  import CompareBoard from '@/components/Dashboard-bmw/CompareBoard/CompareBoard';
  import CustomSelectorBrands from '@/mixins/bmw/customselectorbrands';
  import CustomSelectorWaves from '@/mixins/bmw/customselectorwaves';
  import DashboardPageMixin from '@/mixins/bmw/DashboardPage';
  import ThresholdColorMixin from '@/mixins/bmw/ThresholdColor';
  import DashboardService from '@/services/DashboardService-bmw'
  import CustomTreeSelect from '@/components/Shared/CustomTreeSelect';
  import EventBus from '@/services/EventBus.js'
  import exportelementbutton from './ExportElementButton'
  import LocalizationChangedWithFilter from '@/mixins/LocalizationChangedWithFilter';
  import MultipleResultsLoader from '@/mixins/bmw/compareMultipleResultSets';

  export default {
    mixins: [ ActiveInactiveTexts, BrandMixin, CancelToken,
      CustomSelectorBrands, CustomSelectorWaves, DashboardPageMixin,
      LocalizationChangedWithFilter, MultipleResultsLoader,
      ThresholdColorMixin
    ],

    components: {
      CustomTreeSelect,
      exportelementbutton,
      'compare-board': CompareBoard,
    },

    data() {
      return {
        history: []
      }
    },

    mounted(){
      this.getOptions('mounted');
      EventBus.$on('LocalizationChanged', this.localizationChanged);
    },

    beforeDestroy() {
      EventBus.$off('LocalizationChanged', this.localizationChanged);
    },

    methods: {

      // Get survey structure data for the structure treeselect
      getDashboard(_this) {
        _this.setIsLoading(true);
        _this.isOutdated = false;
        var fltr = _this.filterProperty(_this);
        _this.cockpitCancelToken = this.initCancelToken(_this.cockpitCancelToken);

        this.getMultipleResults(fltr, _this.cockpitCancelToken, _this.optionsdata)
          .then(response => {
            _this.dashdata = [];
            _this.history = [];
            let items = [];
            _.forEach(response, function(res) {
              let dashdataItem = _this.trimKpiNames(res.data);
              dashdataItem.filterStage = res.customFilterStage;
              // Display ClientLocationIdOnClientSite instead of ClientLocationId
              if(dashdataItem.filterStage.mode.name === "outlets") {
                let outletData = [];
                _this.optionsdata.ClientLocations.forEach( function(result) {
                  if (result.id == dashdataItem.filterStage.text) {
                    outletData = result;
                  }
                })
                dashdataItem['outletData'] = outletData;
              }
              items.push(dashdataItem);
            });
            _this.history = _this.getHistory(items);
            _this.dashdata = items;
            _this.isBmwMoto = _this.getIsBmwMoto(_this.selection.Brand);
            _this.isBmwM = _this.getIsBMWM(_this.selection.Brand);
            _this.isBmwi = _this.getIsBMWi(_this.selection.Brand);
            _this.isGebrauchtwagen = _this.getIsGebrauchtwagen(_this.selection.Brand);
            _this.isUsedCar = _this.getIsUsedCar(_this.selection.Brand);
            _this.isUsedBike = _this.getIsUsedBike(_this.selection.Brand);
            _this.isBmw2020 = _this.getIsBmw2020(response.data, _this);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(_ => {
            _this.setIsLoading(false);
          });
      },

      getHistory(items) {
        let history = [];
        _.forEach(items, function(item) {
          _.forEach(item.OverallByWave[0].SurveyWave, function(w) {
            let year = Number(w.Name.slice(0, 2)) + 2000;
            let wave = Number(w.Name.slice(-1));
            let name = w.Name.slice(2);
            let hit = _.find(history, function(x) { return x.year == year && x.wave == wave; });
            if (!hit) {
              history.push({ year: year, wave: wave, name: name });
            }
          });
        });
        // history.push({ year: 2021, wave: 2, name: 'Q2' });
        // history.push({ year: 2021, wave: 1, name: 'Q1' });
        // debugger
        return _.orderBy(history, ['year', 'wave'], ['asc', 'asc']);
      },

      setOptions(_this, sender, opt) {
        _this.settingOptions = true;

        // initially select first item or if children exist, only BMW and MINI
        _this.selectBrands(_this.selection, opt);

        _this.filterSurveys(_this, opt);
        _this.selectSurveys(_this.selection, opt);
        
        // // Wenn keine Survey selektiert
        // if (this.autoFilter.isEnabled && _this.selection.Surveys.length === 0) {
        //   // Default: Alle 2019er Wellen selektieren
        //   // special logic - If "BMW Used Bike" is selected only one survey is allowed
        //   if (!this.getIsUsedBike(_this.selection.Brand))
        //   {
        //     opt.Surveys.forEach(survey => {
        //       if (contextYear === 2019) {
        //         if (survey.year === 2019) {
        //           _this.selection.Surveys.push(survey.id);
        //         }
        //       } else if (contextYear === 2020) {
        //         if (survey.year === 2020) {
        //           _this.selection.Surveys.push(survey.id);
        //         }
        //       }
        //     });
        //   };

        //   // Alle Surveys auswählen
        //   if (_this.selection.Surveys.length === 0) {
        //     for (const survey of opt.Surveys) {
        //       _this.selection.Surveys.push(survey.id);
        //     }
        //   }
        // } else {
        //   // autoFilter is disabled
        //   if (_this.selection.Surveys.length === 0) {
        //     _this.selection.Surveys = opt.Surveys[0].children.map(x => x.id);
        //   }
        // }

        // waves
        this.initializeWaves(_this, sender, opt, 'compare', false);

        // if only one option exists, ensure it is selected
        // opt.XYZ[0].ClientLocationCount === opt.XYZ[0].TotalClientLocationCount ... prevents an auto-select for
        // not fully filled datasets
        if (this.autoFilter.isEnabled)
          this.ensureOptionsAreSetWhenSingleOptionExists(opt, _this.selection);

        opt.Regions = this.setCustomProperties(opt.Regions);
        opt.Subregions = this.setCustomProperties(opt.Subregions);
        opt.NSCs = this.setCustomProperties(opt.NSCs);
        opt.SubNSCs = this.setCustomProperties(opt.SubNSCs);
        opt.Areas = this.setCustomProperties(opt.Areas);
        opt.Dealergroups = this.setCustomProperties(opt.Dealergroups);

        this.setOutlets(opt);

        _this.optionsdata = opt;
        _this.settingOptions = false;
      },

      // Used from shared method: filterProperty; in case of this component, do not inject anything
      applyApiLayerToFilterProperty(filterProps) {
        if (!filterProps)
          filterProps = {};

        filterProps.api = '2021compare';

        return filterProps;
      },

      showEmptyPlaceholder() {
        return this.showPlaceholder && !this.isLoading && !this.dashdata && this.dashdata.length <= 0
      }
    },

    computed: {
      pageState: function() {
        return { isLoading: this.isLoading };
      },

      thresholds: function() {
        // TODO: API für das BMW-Dashboard nicht verfügbar. Migrieren? Wie?
        if (!this.isBmwMoto) {
          return this.thresholdConfig;
        } else {
          return this.motorradDefaultThreshold();
        }
      },
      
      leadFuThresholds() {
        return this.makeLeadFuThresholds(this.thresholds);
      },

      lmThresholds() {
        let xxx = this.getLMThresholds(this.thresholds);
        return xxx;
      }
    }
  }

</script>

<style lang="scss" scoped>
  @use "@/../scss/bmw/dashboardStyles.scss";
</style>
